import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { DimensionService } from "app/analyze/service/dimension-service/dimension.service";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AssetsDataResolver  {

  constructor(private dimensionService: DimensionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.dimensionService.isMAssetDataLoaded().pipe(filter(a => !!a));
  }
}